/**
 * The single source of truth for job lifecycle states (README section 1).
 *
 * The API references this enum in Swagger via `enumName: 'JobStatus'`, the web
 * apps import it directly, and the mobile app receives it through the generated
 * client. Adding a state here without adding its transitions to the domain
 * state machine will fail that machine's exhaustiveness test.
 */
export const JobStatus = {
    DRAFT: 'DRAFT',
    PAYMENT_PENDING: 'PAYMENT_PENDING',
    PAYMENT_FAILED: 'PAYMENT_FAILED',
    SEARCHING_FOR_FIRM: 'SEARCHING_FOR_FIRM',
    NO_COVERAGE: 'NO_COVERAGE',
    ACCEPTED_BY_FIRM: 'ACCEPTED_BY_FIRM',
    ASSIGNED_TO_WORKER: 'ASSIGNED_TO_WORKER',
    WORKER_EN_ROUTE: 'WORKER_EN_ROUTE',
    IN_PROGRESS: 'IN_PROGRESS',
    CHANGE_ORDER_PENDING: 'CHANGE_ORDER_PENDING',
    CANCELLATION_REQUESTED: 'CANCELLATION_REQUESTED',
    COMPLETED: 'COMPLETED',
    CANCELLED_BY_CLIENT: 'CANCELLED_BY_CLIENT',
    CANCELLED_BY_FIRM: 'CANCELLED_BY_FIRM',
    CANCELLED_NO_SHOW: 'CANCELLED_NO_SHOW',
    CANCELLED_ADMIN: 'CANCELLED_ADMIN',
    DISPUTED: 'DISPUTED',
    WARRANTY_CLAIMED: 'WARRANTY_CLAIMED',
};
export const JOB_STATUSES = Object.values(JobStatus);
/** States from which no further transition is legal. */
export const TERMINAL_JOB_STATUSES = [
    JobStatus.NO_COVERAGE,
    JobStatus.CANCELLED_BY_CLIENT,
    JobStatus.CANCELLED_BY_FIRM,
    JobStatus.CANCELLED_NO_SHOW,
    JobStatus.CANCELLED_ADMIN,
];
export const isTerminalJobStatus = (status) => TERMINAL_JOB_STATUSES.includes(status);
//# sourceMappingURL=job-status.js.map